import React from "react";
import {
	Redirect,
	Route,
	RouteComponentProps,
	Switch,
	withRouter,
} from "react-router";

import { Action, Location } from "history";
import { DateTime } from "luxon";

import { IAuthProps } from "./AuthContext";

import withAuth from "./withAuth";

import ToolbarMenu from "./ToolbarMenu";
import ToolbarSource from "./ToolbarSource";
import InnerMenuBar from "./InnerMenuBar";

import DashboardView from "./views/DashboardView";

import AddHealthFairView from "./views/AddHealthFairView";
import HealthFairDayScheduleView from "./views/HealthFairDayScheduleView";
import HealthFairScheduleView from "./views/HealthFairScheduleView";
import HealthFairSearchView from "./views/HealthFairSearchView";
import HealthFairView from "./views/HealthFairView";
import HealthFairPhotosView from "./views/HealthFairPhotosView";
import HealthFairDocumentsView from "./views/HealthFairDocumentsView";
import QuestionnairePrintAllView from "./views/QuestionnairePrintAllView";

import MarketingLeadsView from "./views/MarketingLeadsView";
import MarketingLeadsCreationView from "./views/MarketingLeadsCreationView";

import QuestionnaireCreationView from "./views/QuestionnaireCreationView";
import QuestionnaireListView, {
	DigitalSurveyListView,
} from "./views/QuestionnaireListView";
import QuestionnaireView, {
	DigitalSurveyView,
} from "./views/QuestionnaireView";
import SurveyAdminView from "./views/SurveyAdminView";
import SurveyEditView from "./views/SurveyEditView";
import QuestionnaireAppointmentsView from "./views/QuestionnaireAppointmentsView";
import QuestionnaireContactListView from "./views/QuestionnaireContactListView";

import UserAccountsView from "./views/UserAccountsView";
import UserDetailsView from "./views/UserDetailsView";

import AppointmentCalendarDayView, {
	AppointmentHfCalendarDayView,
} from "./views/AppointmentCalendarDayView";
import AppointmentCalendarView, {
	AppointmentHfCalendarView,
} from "./views/AppointmentCalendarView";
import AppointmentInsuranceListView from "./views/AppointmentInsuranceListView";
import AppointmentInsuranceView from "./views/AppointmentInsuranceView";
import AppointmentContactListView from "./views/AppointmentContactListView";
import AppointmentListView from "./views/AppointmentListView";
import AppointmentPendingView from "./views/AppointmentPendingView";
import AppointmentView from "./views/AppointmentView";
import CreateAppointmentView from "./views/CreateAppointmentView";
import AppointmentTypesAdminView from "./views/AppointmentTypesAdminView";
import AppointmentTypeDetailsView from "./views/AppointmentTypeDetailsView";
import MissedTelemedsView from "./views/MissedTelemedsView";

import EmployeeDetailsView from "./views/EmployeeDetailsView";
import EmployeesView from "./views/EmployeesView";

import GroupDetailsView from "./views/GroupDetailsView";
import GroupsView from "./views/GroupsView";

import LocationDetailsView from "./views/LocationDetailsView";
import LocationsView from "./views/LocationsView";

import RoleDetailsView from "./views/RoleDetailsView";
import RolesView from "./views/RolesView";

import FairLocationDetailsView from "./views/FairLocationDetailsView";
import FairLocationsView, {
	FairLocationsSelectionView,
} from "./views/FairLocationsView";
import FairLocationMergeView from "./views/FairLocationMergeView";
import FairLocationFairListView from "./views/FairLocationFairListView";

import DeviceDetailsView from "./views/DeviceDetailsView";
import DeviceListView from "./views/DeviceListView";

import NotFoundView from "./views/NotFoundView";

import MetricsBonusCalculateView from "./views/MetricsBonusCalculateView";
import MetricsBonusView from "./views/MetricsBonusView";
import MetricsEmployeesView from "./views/MetricsEmployeesView";
import MetricsMarketingView from "./views/MetricsMarketingView";
import MetricsNpCasesView from "./views/MetricsNpCasesView";
import MetricsLocationView from "./views/MetricsLocationView";
import MetricsBigSheetView from "./views/MetricsBigSheetView";
import MetricsCaseStatsGoalEditView from "./views/MetricsCaseStatsGoalEditView";
import MetricsStatementsView from "./views/MetricsStatementsView";
import MetricsFairBookingView from "./views/MetricsFairBookingView";

import MetricsAnalysisView from "./views/MetricsAnalysisView";
import MetricsAnalysisEmployeeView from "./views/MetricsAnalysisEmployeeView";

import MetricsAssessmentsView, {
	MetricsAssessmentsUnreleasedView,
} from "./views/MetricsAssessmentsView";
import MetricsAssessmentUpdateView from "./views/MetricsAssessmentUpdateView";
import MetricsAssessmentDetailsView from "./views/MetricsAssessmentDetailsView";
import MetricsAssessmentTypesView from "./views/MetricsAssessmentTypesView";
import MetricsAssessmentTypeEditView from "./views/MetricsAssessmentTypeEditView";

import MetricsWcasReportView from "./views/MetricsWcasReportView";

import AssessmentSelfView from "./views/AssessmentSelfView";

import SurgeryAppointmentView from "./views/SurgeryAppointmentView";
import SurgeryCalendarDayView from "./views/SurgeryCalendarDayView";
import SurgeryCalendarView from "./views/SurgeryCalendarView";
import SurgeryColorListView from "./views/SurgeryColorListView";
import SurgeryCreationView from "./views/SurgeryCreationView";
import SurgeryListView from "./views/SurgeryListView";
import SurgeryDocumentsView from "./views/SurgeryDocumentsView";
import SurgeryDocumentPrintingView from "./views/SurgeryDocumentPrintingView";
import SurgeryPatientListView from "./views/SurgeryPatientListView";

import SurgeryBookCreationView from "./views/SurgeryBookCreationView";
import SurgeryDeviceCreationView from "./views/SurgeryDeviceCreationView";
import SurgeryDrainCreationView from "./views/SurgeryDrainCreationView";
import SurgeryManagementView from "./views/SurgeryManagementView";
import SurgerySpecimenCreationView from "./views/SurgerySpecimenCreationView";
import SurgeryTypeCreationView from "./views/SurgeryTypeCreationView";
import SurgeryYourCasesView from "./views/SurgeryYourCasesView";
import SurgeryInsuranceCaseListView from "./views/SurgeryInsuranceCaseListView";
import SurgeryInsuranceView from "./views/SurgeryInsuranceView";
import { SurgeryInsuranceOfficeCaseListView } from "./views/SurgeryInsuranceCaseListView";
import SurgeryContactListView from "./views/SurgeryContactListView";
import SurgeryReviewView from "./views/SurgeryReviewView";
import SurgeryPendingDocumentSignView from "./views/SurgeryPendingDocumentSignView";
import DocumentView from "./views/DocumentView";
import CPTListView from "./views/CptListView";

import AuditLogView from "./views/AuditLogView";

import TaskListCreationView from "./views/TaskListCreationView";
import TaskListTaskView from "./views/TaskListTaskView";
import TaskListView from "./views/TaskListView";

import BonusAdminView from "./views/BonusAdminView";
import BonusCreationView from "./views/BonusCreationView";
import BonusSelfView from "./views/BonusSelfView";
import { BonusDetailsView } from "./views/BonusSelfView";

import ScheduleProviderView from "./views/ScheduleProviderView";
import { ScheduleClinicalOutcomesView } from "./views/ScheduleProviderView";
import ScheduleOfficeView from "./views/ScheduleOfficeView";
import ScheduleCoverageView, {
	ScheduleTelemarketerCallView,
	ScheduleSurgicalConsultCallView,
} from "./views/ScheduleCoverageView";
import ScheduleCoverageDetailsView, {
	ScheduleTelemarketerCallDetailsView,
	ScheduleSurgicalConsultCallDetailsView,
} from "./views/ScheduleCoverageDetailsView";
import ScheduleView from "./views/ScheduleView";
import ScheduleVacationView from "./views/ScheduleVacationView";
import { ClinicalOutcomesVacation } from "./views/ScheduleVacationView";

import FilesAdminView from "./views/FilesAdminView";

import AccountingReceiptsView from "./views/AccountingReceiptsView";
import InsuranceCompaniesView from "./views/InsuranceCompaniesView";
import InsuranceCompanyDetailView from "./views/InsuranceCompanyDetailView";
import StatementsListView from "./views/StatementsListView";
import StatementPrintingView from "./views/StatementPrintingView";
import StatementAccountView from "./views/StatementAccountView";

import ConsultListView from "./views/ConsultListView";
import ConsultDetailsView from "./views/ConsultDetailsView";

import TelemedFormListView from "./views/TelemedFormListView";
import TelemedFormView from "./views/TelemedFormView";

import OutreachSurgicalConsultantView, {
	OutreachTelemarketerView,
	OutreachAppointmentSpecialistView,
} from "./views/OutreachSurgicalConsultantView";
import {
	OutreachSurgicalPastContactsView,
	OutreachTelemarketerPastContactsView,
	OutreachAppointmentSepcialistPastContactsView,
} from "./views/OutreachPastContactsView";
import {
	OutreachTelemarketerContactDetailsView,
	OutreachSurgicalConsultantContactDetailsView,
	OutreachAppointmentSpecialistContactDetailsView,
} from "./views/OutreachContactDetailsView";
import {
	OutreachSurgicalOnCallView,
	OutreachTelemarketerOnCallView,
} from "./views/OutreachOnCallView";
import OutreachChartInputView, {
	OutreachChartUploadView,
	OutreachChartSelfInputView,
} from "./views/OutreachChartInputView";
import OutreachLeadListView, {
	OutreachLeadListViewSurgicalConsultant,
} from "./views/OutreachLeadListView";

import EmailOutreachView from "./views/EmailOutreachView";
import EmailOutreachResultsView from "./views/EmailOutreachResultsView";
import EmailOutreachTemplateSelectionView from "./views/EmailOutreachTemplateSelectionView";
import EmailOutreachReviewView from "./views/EmailOutreachReviewView";

import MessagingMessagesView from "./views/MessagingMessagesView";
import MessagingSentRemindersView from "./views/MessagingSentRemindersView";
import MessagingNumberManagementView from "./views/MessagingNumberManagementView";
import MessagingNumberAddView from "./views/MessagingNumberAddView";
import MessagingReminderSettingsView from "./views/MessagingReminderSettingsView";
import MessagingReminderRuleEditView from "./views/MessagingReminderRuleEditView";

import ToolObFlowsheetView from "./views/ToolObFlowsheetView";

import PatientSearchView from "./views/PatientSearchView";
import PatientDocumentUploadView from "./views/PatientDocumentUploadView";
import PatientLandingView from "./views/PatientLandingView";
import PatientEditView from "./views/patient/PatientEditView";
import PatientDocumentEditView from "./views/patient/PatientDocumentEditView";
import DocumentSelectionView from "./views/patient/DocumentSelectionView";
import PatientDocumentVersionListView from "./views/patient/PatientDocumentVersionListView";

import DataListListView from "./views/DataListListView";
import DataListView from "./views/DataListView";

import VehicleListView from "./views/VehicleListView";
import VehicleEditView from "./views/VehicleEditView";
import VehicleDetailsView from "./views/VehicleDetailsView";

import { IS_PRE_RELEASE, VERSION } from "../version";

import "./ViewContainer.css";
import { compareVersions } from "../Utilities";
import FolderView from "./views/FolderView";

interface IViewContainerState {
	title: string;
	errorMessage?: string;
	hasError: boolean;
	isOutdated: boolean;
	borderClass: string;

	canGoBack: boolean;
	showBack: boolean;
}

interface IViewContainerProps extends RouteComponentProps<any>, IAuthProps {
	setDocumentTitle?: boolean;
	onToggleMainMenu?: () => void;
}

type TitleChangeHandler = (
	title: string,
	mode?: "page" | "window" | "both"
) => void;

export interface ITitleContext {
	changeTitle: TitleChangeHandler;
}

export interface IContentStyleContext {
	setBorderStyle: (style: "noborder" | "border") => void;
}

export const TitleContext = React.createContext<ITitleContext>({
	changeTitle: (t) => {
		/* no-op */
	},
});
export const ContentStyleContext = React.createContext<IContentStyleContext>({
	setBorderStyle: (v) => {},
});

class ViewContainer extends React.Component<
	IViewContainerProps,
	IViewContainerState
> {
	constructor(props: Readonly<IViewContainerProps>) {
		super(props);

		this.state = {
			canGoBack: false,
			hasError: false,
			showBack: !(navigator.userAgent.toLowerCase().indexOf("android") > -1),
			title: "TITLE NOT SET",
			isOutdated:
				compareVersions(VERSION, this.props.authContext.minimumVersion) < 0,
			borderClass: "",
		};

		this.changeTitle = this.changeTitle.bind(this);
		this.locationChanged = this.locationChanged.bind(this);
		this.onGoBack = this.onGoBack.bind(this);
		this.setBorderStyle = this.setBorderStyle.bind(this);

		this.props.history.listen(this.locationChanged);
	}

	public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
		this.setState({
			errorMessage: error.message,
			hasError: true,
		});
	}

	public render() {
		if (this.state.hasError) {
			return (
				<div className="main-container">
					<header className="main-header">
						<button
							type="button"
							className="menu-btn menu-btn-toggle icon-bars"
							onClick={this.props.onToggleMainMenu}
						/>
						<span>{this.state.title}</span>
						<ToolbarMenu />
					</header>
					<div className="main-content">
						<div className="error-box">
							<p>
								This app has run into a problem and cannot continue.
								<br />
								Please refresh or close the app and try again.
							</p>
							<p>{this.state.errorMessage}</p>
						</div>
					</div>
				</div>
			);
		}

		return (
			<ToolbarSource>
				<InnerMenuBar.Provider>
					<div className="main-container">
						<header className="main-header">
							{this.state.showBack && this.state.canGoBack ? (
								<button
									type="button"
									className="back-btn back-btn-toggle icon-chevron-left"
									onClick={this.onGoBack}
								/>
							) : (
								""
							)}
							<button
								type="button"
								className="menu-btn menu-btn-toggle icon-bars"
								onClick={this.props.onToggleMainMenu}
							/>
							<span>{this.state.title}</span>
							<ToolbarMenu />
						</header>
						{IS_PRE_RELEASE ? (
							<div className="beta-notice print-hide">
								<span>
									This is pre-release software. You may encounter bugs or
									unfinished features.
								</span>
							</div>
						) : (
							""
						)}
						{this.state.isOutdated ? (
							<div className="outdated-notice print-hide">
								<span>
									<i className="icon-warning" /> You are running an outdated
									version. Some features may not work properly until you update.{" "}
									<i className="icon-warning" />
								</span>
							</div>
						) : (
							""
						)}
						<InnerMenuBar.Host />
						<div className={`main-content ${this.state.borderClass}`}>
							<ContentStyleContext.Provider
								value={{ setBorderStyle: this.setBorderStyle }}>
								<TitleContext.Provider
									value={{ changeTitle: this.changeTitle }}>
									<Switch>
										<Redirect
											exact={true}
											from="/fairs"
											to={`/fairs/schedule/${DateTime.local().toISODate()}`}
										/>
										<Redirect
											exact={true}
											from="/fairs/schedule/today"
											to={`/fairs/schedule/${DateTime.local().toISODate()}`}
										/>
										<Redirect
											exact={true}
											from="/surgery/calendar/today"
											to={`/surgery/calendar/${DateTime.local().toISODate()}`}
										/>

										<Route
											exact={true}
											path="/dashboard"
											component={DashboardView}
										/>
										<Route
											exact={true}
											path="/fairs/add"
											component={AddHealthFairView}
										/>
										<Route
											exact={true}
											path="/fairs/schedule/:date"
											component={HealthFairDayScheduleView}
										/>
										<Route
											exact={true}
											path="/fairs/schedule"
											component={HealthFairScheduleView}
										/>
										<Route
											exact={true}
											path="/fairs/search"
											component={HealthFairSearchView}
										/>
										<Route
											exact={true}
											path="/fairs/:id/edit"
											component={AddHealthFairView}
										/>
										<Route
											exact={true}
											path="/fairs/:id/survey"
											component={QuestionnaireCreationView}
										/>
										<Route
											exact={true}
											path="/fairs/:id/photos"
											component={HealthFairPhotosView}
										/>
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/fairs/:id/documents"
												component={HealthFairDocumentsView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/fairs/:id/documents/:file_id"
												component={DocumentView}
											/>
										)}
										<Route
											exact={true}
											path="/fairs/:id/print-all"
											component={QuestionnairePrintAllView}
										/>
										<Route
											exact={true}
											path="/fairs/:id"
											component={HealthFairView}
										/>
										<Route
											exact={true}
											path="/surveys"
											component={QuestionnaireListView}
										/>
										<Route
											exact={true}
											path="/surveys/outreach"
											component={QuestionnaireContactListView}
										/>
										<Route
											exact={true}
											path="/surveys/:id"
											component={QuestionnaireView}
										/>
										<Route
											exact={true}
											path="/surveys/:surveyid/edit"
											component={QuestionnaireCreationView}
										/>
										<Route
											exact={true}
											path="/surveys/:id/appointments"
											component={QuestionnaireAppointmentsView}
										/>
										<Route
											exact={true}
											path="/users"
											component={UserAccountsView}
										/>
										<Route
											exact={true}
											path="/users/add"
											component={UserDetailsView}
										/>
										<Route
											exact={true}
											path="/users/:id"
											component={UserDetailsView}
										/>
										<Route
											exact={true}
											path="/appointments"
											component={AppointmentListView}
										/>
										<Route
											exact={true}
											path="/appointments/create"
											component={CreateAppointmentView}
										/>
										<Route
											exact={true}
											path="/appointments/pending"
											component={AppointmentPendingView}
										/>
										<Route
											exact={true}
											path="/appointments/calendar/hf/:date"
											component={AppointmentHfCalendarDayView}
										/>
										<Route
											exact={true}
											path="/appointments/calendar/hf"
											component={AppointmentHfCalendarView}
										/>
										<Route
											exact={true}
											path="/appointments/calendar/:date"
											component={AppointmentCalendarDayView}
										/>
										<Route
											exact={true}
											path="/appointments/calendar"
											component={AppointmentCalendarView}
										/>
										<Route
											exact={true}
											path="/appointments/insurance/:type"
											component={AppointmentInsuranceListView}
										/>
										<Route
											exact={true}
											path="/appointments/outreach"
											component={AppointmentContactListView}
										/>
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/appointments/admin"
												component={AppointmentTypesAdminView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/appointments/admin/add"
												component={AppointmentTypeDetailsView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/appointments/admin/:id"
												component={AppointmentTypeDetailsView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/appointments/missed-telemed"
												component={MissedTelemedsView}
											/>
										)}
										<Route
											exact={true}
											path="/appointments/:id/edit"
											component={CreateAppointmentView}
										/>
										<Route
											exact={true}
											path="/appointments/:id/insurance"
											component={AppointmentInsuranceView}
										/>
										<Route
											exact={true}
											path="/appointments/:id"
											component={AppointmentView}
										/>
										<Route
											exact={true}
											path="/consult"
											component={ConsultListView}
										/>
										<Route
											exact={true}
											path="/consult/:id"
											component={ConsultDetailsView}
										/>
										<Route
											exact={true}
											path="/employees"
											component={EmployeesView}
										/>
										<Route
											exact={true}
											path="/employees/add"
											component={EmployeeDetailsView}
										/>
										<Route
											exact={true}
											path="/employees/:id"
											component={EmployeeDetailsView}
										/>
										<Route
											exact={true}
											path="/groups"
											component={GroupsView}
										/>
										<Route
											exact={true}
											path="/groups/add"
											component={GroupDetailsView}
										/>
										<Route
											exact={true}
											path="/groups/:id"
											component={GroupDetailsView}
										/>
										<Route
											exact={true}
											path="/locations"
											component={LocationsView}
										/>
										<Route
											exact={true}
											path="/locations/add"
											component={LocationDetailsView}
										/>
										<Route
											exact={true}
											path="/locations/:id"
											component={LocationDetailsView}
										/>
										<Route
											exact={true}
											path="/roles"
											component={RolesView}
										/>
										<Route
											exact={true}
											path="/roles/add"
											component={RoleDetailsView}
										/>
										<Route
											exact={true}
											path="/roles/:id"
											component={RoleDetailsView}
										/>
										<Route
											exact={true}
											path="/fairtargets"
											component={FairLocationsView}
										/>
										<Route
											exact={true}
											path="/fairtargets/merge"
											component={FairLocationsSelectionView}
										/>
										<Route
											exact={true}
											path="/fairtargets/merge/:left/:right"
											component={FairLocationMergeView}
										/>
										<Route
											exact={true}
											path="/fairtargets/add"
											component={FairLocationDetailsView}
										/>
										<Route
											exact={true}
											path="/fairtargets/:id/edit"
											component={FairLocationDetailsView}
										/>
										<Route
											exact={true}
											path="/fairtargets/:id/fairs"
											component={FairLocationFairListView}
										/>
										<Route
											exact={true}
											path="/fairtargets/:id"
											component={FairLocationDetailsView}
										/>
										<Route
											exact={true}
											path="/devices"
											component={DeviceListView}
										/>
										<Route
											exact={true}
											path="/devices/add"
											component={DeviceDetailsView}
										/>
										<Route
											exact={true}
											path="/devices/:id"
											component={DeviceDetailsView}
										/>

										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/telemed/forms/:id/:form?"
												component={TelemedFormView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/telemed/forms"
												component={TelemedFormListView}
											/>
										)}

										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/digital-surveys"
												component={DigitalSurveyListView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/digital-surveys/:id"
												component={DigitalSurveyView}
											/>
										)}

										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/leads"
												component={MarketingLeadsView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/leads/new"
												component={MarketingLeadsCreationView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/leads/:id"
												component={MarketingLeadsCreationView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/email-outreach"
												component={EmailOutreachView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/email-outreach/results"
												component={EmailOutreachResultsView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/email-outreach/template-selection"
												component={EmailOutreachTemplateSelectionView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/email-outreach/review"
												component={EmailOutreachReviewView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/metrics/employees"
												component={MetricsEmployeesView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/metrics/marketing/hf/fair-booking/:id/:after/:before"
												component={MetricsFairBookingView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/metrics/marketing/:group"
												component={MetricsMarketingView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/metrics/providers"
												component={MetricsNpCasesView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/metrics/location"
												component={MetricsLocationView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/metrics/bonus"
												component={MetricsBonusView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/metrics/bonus/calculate"
												component={MetricsBonusCalculateView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/metrics/bonus/:id"
												component={BonusDetailsView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/metrics/case-stats"
												component={MetricsBigSheetView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/metrics/case-stats/goals/edit"
												component={MetricsCaseStatsGoalEditView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/metrics/analysis/graph"
												component={MetricsAnalysisView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/metrics/analysis/employees"
												component={MetricsAnalysisEmployeeView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/metrics/assessment"
												component={MetricsAssessmentsView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/metrics/assessment/types"
												component={MetricsAssessmentTypesView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/metrics/assessment/types/:assessment_type_id"
												component={MetricsAssessmentTypeEditView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/metrics/assessment/unreleased"
												component={MetricsAssessmentsUnreleasedView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/metrics/assessment/:assessment_id"
												component={MetricsAssessmentDetailsView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/metrics/assessment/employee/:employee_id/:assessment_id"
												component={MetricsAssessmentUpdateView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/metrics/statements"
												component={MetricsStatementsView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/metrics/ad-hoc/wcas-emails"
												component={MetricsWcasReportView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/assessment/:assessment_id"
												component={MetricsAssessmentDetailsView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/assessment"
												component={AssessmentSelfView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery"
												component={SurgeryListView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/contact"
												component={SurgeryContactListView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/insurance/office"
												component={SurgeryInsuranceOfficeCaseListView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/insurance"
												component={SurgeryInsuranceCaseListView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/cases/you"
												component={SurgeryYourCasesView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/cases"
												component={SurgeryColorListView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/review"
												component={SurgeryReviewView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/create"
												component={SurgeryCreationView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/calendar/:date"
												component={SurgeryCalendarDayView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/calendar"
												component={SurgeryCalendarView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/patient-list"
												component={SurgeryPatientListView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/admin"
												component={SurgeryManagementView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/admin/surgerytype/create"
												component={SurgeryTypeCreationView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/admin/surgerytype/:id"
												component={SurgeryTypeCreationView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/admin/specimen/create"
												component={SurgerySpecimenCreationView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/admin/specimen/:id"
												component={SurgerySpecimenCreationView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/admin/device/create"
												component={SurgeryDeviceCreationView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/admin/device/:id"
												component={SurgeryDeviceCreationView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/admin/drain/create"
												component={SurgeryDrainCreationView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/admin/drain/:id"
												component={SurgeryDrainCreationView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/admin/cpts"
												component={CPTListView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/report"
												component={SurgeryBookCreationView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/printing"
												component={SurgeryDocumentPrintingView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/pending-documents"
												component={SurgeryPendingDocumentSignView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/:id/edit"
												component={SurgeryCreationView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/:id/documents"
												component={SurgeryDocumentsView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/:surgery_id/documents/add"
												component={DocumentSelectionView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/:surgery_id/documents/add/:documentType"
												component={PatientDocumentEditView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/:surgery_id/documents/:documentId"
												component={PatientDocumentEditView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/:surgery_id/documents/:documentId/versions"
												component={PatientDocumentVersionListView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/:id/insurance"
												component={SurgeryInsuranceView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgery/:id"
												component={SurgeryAppointmentView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/bonus"
												component={BonusSelfView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/bonus/admin"
												component={BonusAdminView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/bonus/admin/create"
												component={BonusCreationView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/bonus/admin/:id"
												component={BonusCreationView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/schedule/provider"
												component={ScheduleProviderView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/schedule/provider/:id"
												component={ScheduleProviderView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/schedule/clinical-outcomes"
												component={ScheduleClinicalOutcomesView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/schedule/clinical-outcomes/:id"
												component={ScheduleClinicalOutcomesView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/schedule/marketing-vacation"
												component={ScheduleVacationView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/schedule/marketing-vacation/:id"
												component={ScheduleVacationView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/schedule/co-vacation"
												component={ClinicalOutcomesVacation}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/schedule/co-vacation/:id"
												component={ClinicalOutcomesVacation}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/schedule/office"
												component={ScheduleOfficeView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/schedule/coverage"
												component={ScheduleCoverageView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/schedule/coverage/details/:date"
												component={ScheduleCoverageDetailsView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/schedule/telemarketer"
												component={ScheduleTelemarketerCallView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/schedule/telemarketer/details/:date"
												component={ScheduleTelemarketerCallDetailsView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/schedule/surgicalconsultant"
												component={ScheduleSurgicalConsultCallView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/schedule/surgicalconsultant/details/:date"
												component={ScheduleSurgicalConsultCallDetailsView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/schedule"
												component={ScheduleView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/files"
												component={FilesAdminView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/files/:file_id"
												component={DocumentView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/accounting/receipts"
												component={AccountingReceiptsView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/accounting/insurance-companies"
												component={InsuranceCompaniesView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/accounting/insurance-companies/new"
												component={InsuranceCompanyDetailView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/accounting/insurance-companies/:id"
												component={InsuranceCompanyDetailView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/accounting/statements"
												component={StatementsListView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/accounting/statements/printing"
												component={StatementPrintingView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/accounting/statements/:id"
												component={StatementAccountView}
											/>
										)}

										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/survey/admin"
												component={SurveyAdminView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/survey/admin/new"
												component={SurveyEditView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/survey/admin/:id(\d+)"
												component={SurveyEditView}
											/>
										)}

										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgicalconsult/outreach"
												component={OutreachSurgicalConsultantView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgicalconsult/outreach/survey/:id"
												component={OutreachSurgicalConsultantView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgicalconsult/pastcontact"
												component={OutreachSurgicalPastContactsView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgicalconsult/pastcontact/survey/:id"
												component={OutreachSurgicalConsultantContactDetailsView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgicalconsult/pastcontact/survey/:id/appointments"
												component={QuestionnaireAppointmentsView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgicalconsult/on-call"
												component={OutreachSurgicalOnCallView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgicalconsult/on-call/survey/:id"
												component={OutreachSurgicalConsultantView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgicalconsult/leads"
												component={OutreachLeadListViewSurgicalConsultant}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/surgicalconsult/leads/:id"
												component={OutreachSurgicalConsultantContactDetailsView}
											/>
										)}

										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/telemarketing/outreach"
												component={OutreachTelemarketerView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/telemarketing/outreach/survey/:id"
												component={OutreachTelemarketerView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/telemarketing/outreach/lead/:id"
												component={OutreachTelemarketerView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/telemarketing/pastcontact"
												component={OutreachTelemarketerPastContactsView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/telemarketing/pastcontact/survey/:id"
												component={OutreachTelemarketerContactDetailsView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/telemarketing/pastcontact/survey/:id/appointments"
												component={QuestionnaireAppointmentsView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/telemarketing/on-call"
												component={OutreachTelemarketerOnCallView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/telemarketing/on-call/survey/:id"
												component={OutreachTelemarketerView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : this.props.authContext.hasRight("oreach:tm:li:s") ? (
											<Route
												exact={true}
												path="/telemarketing/lead-input"
												component={OutreachChartSelfInputView}
											/>
										) : (
											<Route
												exact={true}
												path="/telemarketing/lead-input"
												component={OutreachChartInputView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/telemarketing/leads"
												component={OutreachLeadListView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/telemarketing/leads/:id"
												component={OutreachTelemarketerContactDetailsView}
											/>
										)}

										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/appointmentspecialist/outreach"
												component={OutreachAppointmentSpecialistView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={false}
												path="/appointmentspecialist/outreach/survey/:id"
												component={OutreachAppointmentSpecialistView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/appointmentspecialist/lead-upload"
												component={OutreachChartUploadView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/appointmentspecialist/pastcontact"
												component={
													OutreachAppointmentSepcialistPastContactsView
												}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/appointmentspecialist/pastcontact/survey/:id"
												component={
													OutreachAppointmentSpecialistContactDetailsView
												}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/appointmentspecialist/pastcontact/survey/:id/appointments"
												component={QuestionnaireAppointmentsView}
											/>
										)}

										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/reminders/messages/new"
												component={MessagingMessagesView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/reminders/messages/:threadId"
												component={MessagingMessagesView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/reminders/messages"
												component={MessagingMessagesView}
											/>
										)}

										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/reminders/sent"
												component={MessagingSentRemindersView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/reminders/numbers"
												component={MessagingNumberManagementView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/reminders/numbers/add"
												component={MessagingNumberAddView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/reminders/numbers/:id"
												component={MessagingNumberManagementView}
											/>
										)}

										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/reminders/settings"
												component={MessagingReminderSettingsView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/reminders/settings/rules/new"
												component={MessagingReminderRuleEditView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/reminders/settings/rules/:id"
												component={MessagingReminderRuleEditView}
											/>
										)}

										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/tools/ob-flowsheet"
												component={ToolObFlowsheetView}
											/>
										)}

										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/vehicles"
												component={VehicleListView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/vehicles/new"
												component={VehicleEditView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/vehicles/:id/edit"
												component={VehicleEditView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/vehicles/:id"
												component={VehicleDetailsView}
											/>
										)}

										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/patient/search"
												component={PatientSearchView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/patient/document-import"
												component={PatientDocumentUploadView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/patient/document-import/:id"
												component={PatientDocumentUploadView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/patient/:id/edit"
												component={PatientEditView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/patient/:patient_id/documents/add"
												component={DocumentSelectionView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/patient/:patient_id/documents/add/:documentType"
												component={PatientDocumentEditView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/patient/:patient_id/documents/:documentId"
												component={PatientDocumentEditView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/patient/:patient_id/documents/:documentId/versions"
												component={PatientDocumentVersionListView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={false}
												path="/patient/:id"
												component={PatientLandingView}
											/>
										)}

										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/data-lists"
												component={DataListListView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/data-lists/new"
												component={DataListView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/data-lists/:id"
												component={DataListView}
											/>
										)}

										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/folders"
												component={FolderView}
											/>
										)}
										{this.props.authContext.serverType ? (
											""
										) : (
											<Route
												exact={true}
												path="/folders/:id"
												component={FolderView}
											/>
										)}

										<Route
											exact={true}
											path="/auditlog"
											component={AuditLogView}
										/>
										<Route
											exact={true}
											path="/tasks"
											component={TaskListView}
										/>
										<Route
											exact={true}
											path="/tasks/new"
											component={TaskListCreationView}
										/>
										<Route
											exact={true}
											path="/tasks/:id"
											component={TaskListTaskView}
										/>
										<Route
											exact={true}
											path="/"
											component={DashboardView}
										/>
										<Route component={NotFoundView} />
									</Switch>
								</TitleContext.Provider>
							</ContentStyleContext.Provider>
						</div>
					</div>
				</InnerMenuBar.Provider>
			</ToolbarSource>
		);
	}

	private changeTitle(title: string, mode: string = "both") {
		if (mode === "window") {
			if (this.props.setDocumentTitle) {
				document.title = title;
			}
			return;
		}

		this.setState((s, p) => {
			if (mode === "both" && this.props.setDocumentTitle) {
				document.title = title;
			}

			return { title };
		});
	}

	private onGoBack() {
		this.props.history.goBack();
	}

	private locationChanged(location: Location, action: Action) {
		this.setState({
			canGoBack:
				location.pathname !== "/dashboard" && this.props.history.length > 1,
		});
	}

	private setBorderStyle(borderStyle: "noborder" | "border" = "border") {
		this.setState({
			borderClass: borderStyle === "noborder" ? "content-no-border" : "",
		});
	}
}

export default withAuth(withRouter(ViewContainer));
